import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import { LinearProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import PaypalCheckout from "./PaypalCheckout";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

// Преобразует код языка в формат PayPal locale (например, "ru" -> "ru_RU", "en" -> "en_US")
const getPaypalLocale = (language) => {
  const languageMap = {
    ru: "ru_RU",
    en: "en_US",
    de: "de_DE",
    fr: "fr_FR",
    es: "es_ES",
    it: "it_IT",
    pt: "pt_PT",
    pl: "pl_PL",
    zh: "zh_CN",
    ja: "ja_JP",
    ko: "ko_KR",
  };

  // Если язык уже в формате XX_XX, возвращаем как есть
  if (language.includes("_")) {
    return language;
  }

  // Иначе преобразуем через маппинг или добавляем суффикс
  return languageMap[language] || `${language}_${language.toUpperCase()}`;
};

export default function PaypalPaymentForm({
  paymentData,
  returnUrl,
  paymentId,
  setError,
  descriptionComponent,
  paymentHasError,
  setPaymentHasError,
}) {
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();

  // Объединяем существующие опции с параметром locale
  const paypalOptions = useMemo(() => {
    const locale = getPaypalLocale(i18n.language);
    return {
      ...paymentData.providerOptions,
      locale,
    };
  }, [paymentData.providerOptions, i18n.language]);

  return (
    <>
      {loading && <LinearProgress />}
      <PayPalScriptProvider deferLoading={false} options={paypalOptions}>
        <PaypalCheckout
          paymentId={paymentId}
          setLoading={setLoading}
          setError={setError}
          loading={loading}
          paymentData={paymentData}
          returnUrl={returnUrl}
          descriptionComponent={descriptionComponent}
          paymentHasError={paymentHasError}
          setPaymentHasError={setPaymentHasError}
        />
      </PayPalScriptProvider>
    </>
  );
}

PaypalPaymentForm.propTypes = {
  paymentHasError: PropTypes.bool,
  setPaymentHasError: PropTypes.func.isRequired,
  paymentId: PropTypes.string.isRequired,
  paymentData: PropTypes.shape({
    providerOptions: PropTypes.shape({
      currency: PropTypes.string.isRequired,
      "client-id": PropTypes.string.isRequired,
      vault: PropTypes.bool,
      intent: PropTypes.string.isRequired,
      components: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  descriptionComponent: PropTypes.object,
  setError: PropTypes.func,
  returnUrl: PropTypes.string.isRequired,
};
